import styled from 'styled-components';
import HotelIconSvg from '../assets/hotels/home/hotel.svg';

const HotelIcon = styled(HotelIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props =>
    props.fill ||
    (props.isActive ? props.theme.colors.goBrand.blue : props.theme.colors.grey.grey50)};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default HotelIcon;
